<template>
	<v-app>
		<core-toolbar />

		<core-drawer />

		<core-view />

		<v-snackbar v-model="snackbar" :color="color" :timeout="6000">
			{{text}}
			<v-btn dark text @click="snackbar = false">Close</v-btn>
		</v-snackbar>

		<!-- these components have no templates but use the vue lifecycle hooks to do certain operations --> 
		<WebSocket />
		<UserPermissions />
	</v-app>
</template>

<style lang="scss">
	.v-navigation-drawer .v-list {
		background-image: linear-gradient(to bottom, #0069bb, #203360) !important;
	}
</style>

<script>
	// force pipeline 
	import { AmplifyEventBus } from "aws-amplify-vue";
	import { Logger } from "aws-amplify";
	const logger = new Logger("App");
	import Auth from "@/services/Auth";
	import WebSocket from "@/components/system/WebSocket.vue"
	import UserPermissions from "@/components/system/UserPermissions"
	
	export default {
		components: { WebSocket, UserPermissions },

		data: () => ({
			snackbar: false,
			color: "",
			text: "",
			refreshInterval: false // interval for token refreshing!
		}),
		beforeMount () {
			// we want to refresh our tokens manually every 5 minutes in case the user is inactive for long periods of time
			if(!this.refreshInterval) {
				this.refreshInterval = setInterval(() => {
					logger.debug(`tokens refreshed`)
					Auth.Refresh();
				}, 300000);
			}
		},
		mounted() {
			AmplifyEventBus.$on("authState", info => {
				logger.info(
					"Here is the auth event that was just emitted by an Amplify component: ",
					info
				);
			});
			AmplifyEventBus.$on("snackEvent", info => {
				logger.info(info);
				this.toggleSnackbar(info);
			});
			//service worker example
			setTimeout(() => {
				if (this.$serviceWorker)
					this.$serviceWorker.send({
						message: "heheda"
					});
			}, 3000);
		},
		destroyed () {
			clearInterval(this.refreshInterval);
		},
		metaInfo() {
			return {
				title: "ProVision Vehicle Cameras Dashboard"
			};
		},
		methods: {
			toggleSnackbar({ color, text }) {
				this.color = color;
				this.text = text;
				this.snackbar = true;
			}
		}
	};
</script>

<style lang="scss">
	.v-snack:not(.v-snack--absolute) {
    height: 100vh;
    position: fixed;
    z-index: 9999;
	}
</style>

